import type { IChatWithDetails } from '@rpgc-ai/shared-interfaces/interfaces/chat.interface';
import type { IPaginationMeta } from '@rpgc-ai/shared-interfaces/interfaces/chats.interface';

import type { IChatsFilters } from './chats.store';

export interface IChatsState {
  chats: IChatWithDetails[] | null;
  chatsCount: number;
  isLoading: boolean;
  error: string | null;
  filters: IChatsFilters;
  meta: IPaginationMeta | null;
  navigateOnSuccess: boolean;
}

export const initialChatsState: IChatsState = {
  chats: null,
  chatsCount: 0,
  isLoading: false,
  error: null,
  filters: {
    search: null,
    limit: 30,
    page: 1,
  },
  meta: null,
  navigateOnSuccess: false,
};
